<template>
  <ul>
    <li
      v-for="item in items"
      :key="item.id"
      :style="[{ 'border-color': iconColor }]"
      :class="{ expanded: showChildren(item), parent: item.groupId }"
    >
      <a
        @click="onSelect(item, $event)"
        :target="item.isExternal ? '_blank' : null"
        v-bind:class="{
          external: item.isExternal,
          'close-panel': !hasChildren(item),
        }"
        class="nav-item"
        data-panel="left"
      >
          <span
            class="icon"
            :class="getIconClass(item.iconId)"
            :style="{ color: iconColor }"
          >
          </span>

          <span class="text" :style="{ color: fontColor }">{{
            item.text
          }}</span>
        <span
          v-if="hasChildren(item)"
          :style="{ 'border-left-color': fontColor }"
          class="list-arrow"
        ></span>
      </a>
      <transition name="expand" :duration="1000">
        <ListMenu
          v-show="showChildren(item)"
          class="inner-list"
          :items="item.children"
          :iconColor="iconColor"
          :fontColor="fontColor"
          @onClick="onClick($event)"
        ></ListMenu>
      </transition>
    </li>
  </ul>
</template>

<script>
import iconHelper from '../../helpers/menu.icon.helper'

export default {
  name: 'ListMenu',
  props: {
    items: {
      required: true,
      default: function () {
        return []
      }
    },
    iconColor: {
      type: String
    },
    fontColor: {
      type: String
    }
  },
  methods: {
    getIconClass (iconId) {
      return iconHelper.getIconClassById(iconId)
    },
    onSelect (item, e) {
      if (this.hasChildren(item)) {
        e.stopPropagation()
        this.selectedItem =
          this.selectedItem && this.selectedItem.id === item.id ? null : item
      } else {
        this.onClick(item)
      }
    },
    onClick (item) {
      this.$emit('onClick', item)
    },
    showChildren (parent) {
      return this.selectedItem && this.selectedItem.id === parent.id
    },
    hasChildren (item) {
      return item.children && item.children.length
    }
  },
  data () {
    return {
      selectedItem: null
    }
  }
}
</script>

<style scoped lang="scss">
ul {
  margin: 0;
  padding: 0;
  li {
    position: relative;
    z-index: 0;
    border-top-width: 1px;
    border-top-style: solid;
    &.expanded {
      //border-top-width: 0px;
      .list-arrow {
        transform: rotate(90deg);
      }
    }
    &:first-child {
      border-top-width: 0px;
    }
    .nav-item {
      display: flex;
      align-items: center;
      padding: 12px 18px;
      box-sizing: border-box;
      justify-content: space-between;
      font-size: 16px;
      overflow: hidden;
      column-gap: 14px;
      // > div {
      //   flex: 1;
      //   overflow: hidden;
      // }

      .icon {
        font-size: 24px;
        flex-shrink: 0;
        padding: 0;
        // vertical-align: middle;
        img {
          max-width: 24px;
          max-height: 24px;
        }
      }
      .text {
        flex:1;
        text-wrap: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &.active {
        font-weight: 800;
      }

      .list-arrow{
        flex-shrink: 0;
        margin-left: auto;
      }
    }
  }
  ul.inner-list {
    overflow: hidden;
    margin-left: 32px;
    li {
      z-index: 1;
      border: transparent;
    }
  }
}

.list-arrow {
  width: 0;
  height: 0;
  border-left: 6px solid;
  border-bottom: 6px solid transparent;
  border-top: 6px solid transparent;
  transition: 0.5s;
}

.expand-leave-active,
.expand-enter-active {
  //max-height: 60px;
  transition: max-height 0.1s ease-out;
}
.expand-enter,
.expand-leave-to {
  max-height: 0;
  li {
    border-top: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// list-menu-component.vue?fd7bdb32